import { clsx } from 'clsx'
import { useEffect } from 'preact/hooks'

import { DoneIcon, LoadingIcon, Typography, Workspace } from 'components/UI'
import { handleBeforeUnload } from 'utils'

import { useWorkspace } from './state'

const DAppWorkspaceTab = () => {
	const { envId, ready, wkStates } = useWorkspace()
	const isLoading = !envId || !ready

	useEffect(() => {
		window.addEventListener('beforeunload', handleBeforeUnload)

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload)
		}
	}, [])

	return (
		<>
			<div
				class={clsx(
					'absolute grid h-full w-full place-items-center transition-opacity delay-150 duration-1000 ease-in-out',
					isLoading ? 'duration-1000' : 'opacity-0'
				)}
			>
				<div class='space-y-5 rounded-md bg-black-800 py-5 pl-5 pr-24'>
					<Typography text='Opening Workspace' variant='h3' />

					<ul class='space-y-2'>
						{wkStates.map(state => (
							<li class='flex flex-row items-center space-x-2' key={state.name}>
								{state.done ? (
									<DoneIcon class='text-product' />
								) : (
									<LoadingIcon
										class={clsx(
											'text-product opacity-0',
											state.active && 'opacity-100'
										)}
									/>
								)}
								<div class='flex flex-col space-y-1'>
									<Typography
										color={
											state.active && !state.done
												? 'text-product'
												: 'text-black-400'
										}
										text={state.name}
										variant='text2'
									/>
									{state.warning && (
										<Typography
											color='text-warning'
											text={state.warning}
											variant='text3'
										/>
									)}
								</div>
							</li>
						))}
					</ul>
				</div>
			</div>

			<div class='absolute h-full w-full'>
				<Workspace envId={envId} />
			</div>
		</>
	)
}

export { DAppWorkspaceTab }
